import { getCanvas, getContext, imageAssets, Sprite } from "kontra";

export class Planets {

  private planets: Sprite[];

  constructor() {
    const numOfPlanets = Math.floor(Math.random() * 4);
    this.planets = (new Array(numOfPlanets)).fill(null).map(_ => this.getRandomPlanet());
  }

  getRandomPlanet() {
    const planetDraw = Math.random();

    let chosenPlanet;
    switch (true) {
      case planetDraw < 0.25:
        chosenPlanet = imageAssets.baren;
        break;
      case planetDraw < 0.5:
        chosenPlanet = imageAssets.lava;
        break;
      case planetDraw < 0.75:
        chosenPlanet = imageAssets.terran;
        break;
      default:
        chosenPlanet = imageAssets.ice;
        break;
    }

    const randomScale = Math.random() + 0.5;

    return Sprite({
      x: Math.random() * getCanvas().width,
      y: Math.random() * getCanvas().height,
      image: chosenPlanet,
      scaleX: randomScale,
      scaleY: randomScale,
      radius: 24 * randomScale,
      anchor: { x: 0.5, y: 0.5 }
    });
  }

  render() {
    const context = getContext();

    this.planets.forEach((planet) => {
      planet.render()
      // context.fillStyle = `rgba(0,0,0,${(-0.5 * planet.scaleX + 0.75)})`;
      context.fillStyle = `rgba(0,0,0,${(-0.8 * planet.scaleX + 1.2)})`;
      context.beginPath();
      context.arc(planet.x, planet.y, planet.radius, 0, 2 * Math.PI);
      context.fill();
    })
  }
}